import React, { Fragment, useEffect, useState } from 'react';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import {
  Typography,
  Button,
  Form,
  message,
  Card,
  Input,
  Select,
  Radio,
  Space,
  Row,
  Col,
  Modal,
  Spin,
  TreeSelect,
} from 'antd';
import Axios from 'axios';
import config from '../../Config/key';
import { useSelector } from 'react-redux';
import { filterAccessibleSeasons } from '../../../utils/seasonFilter';
// 組織情報管理（確定組織表）連携: シーズン開始日時点の部署ソースへ切替（Ph.4d）
import {
  DEPT_TREE_SELECT_PROPS,
  buildDepartmentTree,
} from '../../../utils/orgReportFilter';
// 系列会社ありグループの系列会社 Select・系列会社別の部署ソース（「グループ会社・系列会社構造」PJ Ph.4b）
import { resolveCompanyRule } from '../../../utils/companyRule';
import {
  COMPANY_ALL_VALUE,
  fetchDeptPathsForCompany,
  companyChoices,
  normalizeCompanySelection,
  toYmdDash,
} from '../../../utils/companyDeptSource';
import CompanySelectBlock from './CompanySelectBlock';
import { CarryOutOutlined } from '@ant-design/icons';
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
let dpObj = {
  //所属部署の全ての経路を含むリスト、段階別に区別
  dp1: [],
  dp2: [],
  dp3: [],
  dp4: [],
  dp5: [],
};
let dpText = {
  //所属部署の全ての経路を含むリスト、段階別に区別
  dp1: '',
  dp2: '',
  dp3: '',
  dp4: '',
  dp5: '',
};
const PDF10010CompanyDowlnoadPage = () => {
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //選択されたグループ情報
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグループコード
  const [selGroupDepartment, setSelGroupDepartment] = useState([]); //選択されたグループの部署のRadio Option、第一部署
  const [selGroupDepartmentLong, setSelGroupDepartmentLong] = useState([]); //選択されたグループの部署のRadio Option、Full
  const [depArrLong, setDepArrLong] = useState([]); //選択されたグループの部署配列、Full
  const [depArr, setDepArr] = useState([]); //選択されたグループの部署配列、第一部署
  const [survey, setSurvey] = useState([]); //全てのサーベイ情報
  // const [questionSet, setQuestionSet] = useState([]); //全てのサーベイ情報
  // const [selQuestionSetId, setSelQuestionSetId] = useState(''); //全てのサーベイ情報
  // const [selSurveyInfo, setSelSurveyInfo] = useState([]); //選択されたサーベイ情報
  const [positionArr, setPositionArr] = useState([]);
  const [levelCodeArr, setLevelCodeArr] = useState([]);
  const [goOutArr, setGoOutArr] = useState([]);
  const [selSurveyInfo, setSelSurveyInfo] = useState([]); //選択されたサーベイ情報
  const [groupSurveySeasonInfo, setGroupSurveySeasonInfo] = useState([]); //選択されたグループに存在するサーベイシーズン
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]); //選択されたサーベイシーズン情報
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択されたサーベイシーズンID
  const [submitSW, setSubmitSW] = useState(true); //SubmitボタンDisable調整 true => 表示
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [depAll, setDepAll] = useState(0); //詳細、部署選択、0:全体、1:部署選択
  const [treeData, setTreeData] = useState([]);
  const [selTree, setSelTree] = useState('');
  // 確定組織表を使用中の場合の基準日（'YYYY-MM-DD'）。空なら Group.department（従来）を使用中。
  const [orgNoticeDate, setOrgNoticeDate] = useState('');
  // 系列会社 Select（系列会社ありグループのみ表示。'' = 全社（グループ全体））
  const [companyNames, setCompanyNames] = useState([]);
  const [selCompany, setSelCompany] = useState(COMPANY_ALL_VALUE);
  const [radio, setRadio] = useState({
    radio01: 0, //詳細、役職選択、0:全体、1:役職選択
    radio02: 0, //詳細、性別選択、0:全体、1:男性、2:女性
    radio03: depAll, //詳細、部署選択、0:全体、1:部署選択
    radio04: 0, //詳細、年齢指定,0:全体、1:年齢指定
    radio05: 0, //詳細、等級選択、0:全体、1:等級選択
    radio06: 0, //詳細、出向状態選択、0:全体、1:出向状態選択
    radio07: 19, //詳細、終了年齢指定
    radio08: 75, //詳細、終了年齢指定
    department0: '', //詳細、選択部署Text
    position: '',
    levelCode: '',
    goOut: '',
  });
  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log({ usr });
      setUserInfo(usr.userData);
      // const groupInfo = await Axios.get('api/group/');

      const [surveyInfo, groupInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/10010'), //DBからグループ情報取得
        // Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);
      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }
      // setGroups(groupInfo.data.groups);
      setSurvey(surveyInfo.data.survey);

      if (!groups) throw new Error('グループ取得に失敗しました。');
      if (!survey) throw new Error('サーベイ取得に失敗しました。');
      if (usr.userData.role === 3) {
        //企業管理者
        // onChangeGroup(usr.userData.groupCode);
        let sgi = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );

        // console.log({ sgi });
        setTreeData(genTree(sgi.department));
        setSelGroupCode(usr.userData.groupCode);
        setSelGroupInfo(sgi);
        setGroupSurveySeasonInfo(
          filterAccessibleSeasons(sgi.survey_season, usr.userData, ['10010', '90101'])
        );
        initGroup(usr.userData.groupCode, sgi);
        loadCompanyChoices(usr.userData.groupCode, sgi, toYmdDash(), COMPANY_ALL_VALUE);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  const initGroup = (value, sgi) => {
    // let sgi = groups.find((item) => item.group_code === value);
    // console.log({ groups });
    setSelGroupCode(value);
    setSelGroupInfo(sgi);
    setPositionArr(sgi.position);
    setLevelCodeArr(sgi.level_code);
    setGoOutArr(sgi.go_out);
    setRadio({
      ...radio,
      radio03: depAll,
    });
    dpText = {
      dp1: '',
      dp2: '',
      dp3: '',
      dp4: '',
      dp5: '',
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    dpObj = {
      dp1: [],
      dp2: [],
      dp3: [],
      dp4: [],
      dp5: [],
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    const dp = [];
    for (let i = 0; i < sgi.department.length; i++) {
      if (sgi.department[i].split('／').length < 2) {
        dp.push(sgi.department[i]);
      }
    }

    for (let i = 0; i < sgi.department.length; i++) {
      let dArr = sgi.department[i].split('／');
      if (dArr.length === 1) {
        dpObj.dp1.push(sgi.department[i]);
      }
      if (dArr.length === 2) {
        dpObj.dp2.push(sgi.department[i]);
      }
      if (dArr.length === 3) {
        dpObj.dp3.push(sgi.department[i]);
      }
      if (dArr.length === 4) {
        dpObj.dp4.push(sgi.department[i]);
      }
      if (dArr.length === 5) {
        dpObj.dp5.push(sgi.department[i]);
      }
    }
    let selectArr = [];
    for (let i = 0; i < dpObj.dp1.length; i++) {
      const element = dpObj.dp1[i];
      selectArr.push(<Option key={element}>{element}</Option>);
    }

    // console.log(dpObj);
    const child = [];
    const dep = [];
    const childLong = [];
    const depLong = [];

    for (let i = 0; i < dp.length; i++) {
      const element = dp[i];
      child.push(<Option key={element}>{element}</Option>);
      dep.push(element);
    }
    for (let i = 0; i < sgi.department.length; i++) {
      const element = sgi.department[i];
      childLong.push(<Option key={element}>{element}</Option>);
      depLong.push(element);
    }
    setSelGroupDepartmentLong(childLong); //部署選択RadioのOption、Longバージョン
    setDepArrLong(depLong); //部署名の配列、Longバージョン
    setSelGroupDepartment(child); //部署選択RadioのOption、第一部署
    setDepArr(dep); //部署名の配列、第一部署
  };

  // 部署経路 → TreeSelect 用ツリー（共用ヘルパー。7 階層・親は経路の完全一致で解決）
  const genTree = (depArr) =>
    buildDepartmentTree(depArr, { icon: <CarryOutOutlined /> });

  // ---- 系列会社 Select（「グループ会社・系列会社構造」PJ Ph.4b）----
  // 系列会社ありグループ（Group.has_affiliates === true）か
  const isAffiliate = !!selGroupInfo && selGroupInfo.has_affiliates === true;

  // 系列会社の選択肢を読み込み、選択値を補正して返す。系列会社なしグループは API を呼ばず '' を返す
  // （本画面は role [2,9] のみのため role 7 の会社制限は無い）
  const loadCompanyChoices = async (groupCode, sgi, dateStr, current) => {
    if (!sgi || sgi.has_affiliates !== true) {
      setCompanyNames([]);
      setSelCompany(COMPANY_ALL_VALUE);
      return COMPANY_ALL_VALUE;
    }
    const rule = await resolveCompanyRule(groupCode, sgi, dateStr);
    const choices = companyChoices(rule.names, null);
    const next = normalizeCompanySelection(current, choices);
    setCompanyNames(choices.names);
    setSelCompany(next);
    return next;
  };

  // 系列会社の変更: 部署選択を初期化し、その系列会社の部署一覧でツリーを作り直す
  const onChangeCompany = async (value) => {
    const company = value || COMPANY_ALL_VALUE;
    setSelCompany(company);
    await applyOrgDepartmentSource(selSurveySeasonInfo, company);
    setRadio((prev) => ({ ...prev, radio03: 0, department0: '' }));
  };

  const onChangeGroup = (value) => {
    let sgi = groups.find((item) => item.group_code === value);
    // console.log(sgi.department);
    setTreeData(genTree(sgi.department));
    setSelTree('');
    setOrgNoticeDate(''); // 企業変更でシーズン未選択に戻るため組織表案内をクリア
    // 系列会社は企業変更で「全社」に戻す（系列会社ありグループのみ選択肢を取得）
    setSelCompany(COMPANY_ALL_VALUE);
    setCompanyNames([]);
    loadCompanyChoices(value, sgi, toYmdDash(), COMPANY_ALL_VALUE);
    setSelGroupCode(value);
    setSelGroupInfo(sgi);

    setPositionArr(sgi.position);
    setLevelCodeArr(sgi.level_code);
    setGoOutArr(sgi.go_out);
    setRadio({
      ...radio,
      radio03: depAll,
    });
    dpText = {
      dp1: '',
      dp2: '',
      dp3: '',
      dp4: '',
      dp5: '',
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    dpObj = {
      dp1: [],
      dp2: [],
      dp3: [],
      dp4: [],
      dp5: [],
    };
    // setGroupSurveySeasonInfo(sgi.survey_season);
    const dp = [];
    for (let i = 0; i < sgi.department.length; i++) {
      if (sgi.department[i].split('／').length < 2) {
        dp.push(sgi.department[i]);
      }
    }

    for (let i = 0; i < sgi.department.length; i++) {
      let dArr = sgi.department[i].split('／');
      if (dArr.length === 1) {
        dpObj.dp1.push(sgi.department[i]);
      }
      if (dArr.length === 2) {
        dpObj.dp2.push(sgi.department[i]);
      }
      if (dArr.length === 3) {
        dpObj.dp3.push(sgi.department[i]);
      }
      if (dArr.length === 4) {
        dpObj.dp4.push(sgi.department[i]);
      }
      if (dArr.length === 5) {
        dpObj.dp5.push(sgi.department[i]);
      }
    }
    let selectArr = [];
    for (let i = 0; i < dpObj.dp1.length; i++) {
      const element = dpObj.dp1[i];
      selectArr.push(<Option key={element}>{element}</Option>);
    }

    // setDpState1(...dpState1, dpObj.dp1 )

    // console.log(dpObj);
    const child = [];
    const dep = [];
    const childLong = [];
    const depLong = [];

    for (let i = 0; i < dp.length; i++) {
      const element = dp[i];
      child.push(<Option key={element}>{element}</Option>);
      dep.push(element);
    }
    for (let i = 0; i < sgi.department.length; i++) {
      const element = sgi.department[i];
      childLong.push(<Option key={element}>{element}</Option>);
      depLong.push(element);
    }
    setSelGroupDepartmentLong(childLong); //部署選択RadioのOption、Longバージョン
    setDepArrLong(depLong); //部署名の配列、Longバージョン
    setSelGroupDepartment(child); //部署選択RadioのOption、第一部署
    setDepArr(dep); //部署名の配列、第一部署

    setGroupSurveySeasonInfo(
      filterAccessibleSeasons(sgi.survey_season, usr.userData, ['10010', '90101'])
    );
    setSelSurveySeasonId('');
    // setSelQuestionSetId('');
    // setQuestionSet([]);
  };

  // Date → 'YYYY-MM-DD'（組織表 API の date パラメータ・案内表示用）
  const ymdDash = (tdate) => {
    const date = new Date(tdate);
    return (
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2)
    );
  };

  // 部署経路配列（Group.department または組織表由来）から treeData / selTree を再構築。
  // 本画面は role 7 分岐（genTree2）を持たない（ルートは role [2,9] のみ）ため genTree + 選択初期化のみ。
  const rebuildTree = (paths) => {
    const src = Array.isArray(paths) ? paths : [];
    setTreeData(genTree(src));
    setSelTree('');
  };

  // 選択シーズンの開始日時点で有効な確定組織表があれば部署ソースをそれに切替、
  // 無ければ Group.department（従来）へフォールバック。案内表示も更新する。
  // 系列会社ありグループ（Ph.4b）は company（'' = 全社）の系列会社配下の部署に絞り、組織表が無ければ
  // ユーザーの所属から導出した部署一覧を使う（fetchDeptPathsForCompany）
  const applyOrgDepartmentSource = async (sssi, company) => {
    let paths = (selGroupInfo && selGroupInfo.department) || [];
    let orgActive = false;
    if (sssi && sssi.survey_start_date) {
      const dateStr = ymdDash(sssi.survey_start_date);
      const result = await fetchDeptPathsForCompany(selGroupCode, company, dateStr, {
        affiliate: isAffiliate,
      });
      if (result) {
        paths = result.paths;
        if (result.source === 'org') {
          orgActive = true;
          setOrgNoticeDate(dateStr);
        }
      }
    }
    if (!orgActive) setOrgNoticeDate('');
    rebuildTree(paths);
  };

  const onChangeSurveySeason = async (value) => {
    const sssi = groupSurveySeasonInfo.find((item) => item._id === value); //selSurveySeasonInfo
    setSelSurveySeasonId(value);
    setSelSurveySeasonInfo(sssi);

    // 系列会社ありグループはシーズン開始日時点の系列会社一覧で選択肢を更新（無い会社なら全社へ補正）
    const company = await loadCompanyChoices(
      selGroupCode,
      selGroupInfo,
      toYmdDash(sssi && sssi.survey_start_date),
      selCompany
    );
    // シーズン変更で部署ソース（確定組織表 or Group.department）を切替・選択値を初期化
    await applyOrgDepartmentSource(sssi, company);

    setRadio({
      radio01: 0, //詳細、役職選択、0:全体、1:役職選択
      radio02: 0, //詳細、性別選択、0:全体、1:男性、2:女性
      radio03: depAll, //詳細、部署選択、0:全体、1:部署選択
      radio04: 0, //詳細、年齢指定,0:全体、1:年齢指定
      radio05: 0, //詳細、等級選択、0:全体、1:等級選択
      radio06: 0, //詳細、出向状態選択、0:全体、1:出向状態選択
      radio07: 19, //詳細、終了年齢指定
      radio08: 75, //詳細、終了年齢指定
      department0: '', //詳細、選択部署Text
      position: '',
      levelCode: '',
      goOut: '',
    });

    // console.log({ sssi });
    const ssi = survey.find((item) => item._id === sssi.survey_id);
    setSelSurveyInfo(ssi);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      setIsModalVisible(true);
      setSubmitSW(false);
      const sendData = {
        selGroupInfo: selGroupInfo,
        selSurveySeasonInfo: selSurveySeasonInfo,
        // 系列会社ありグループのみ company（'' = 全社）を送る（系列会社なしグループは従来どおりキー無し）
        searchInfo: isAffiliate
          ? { ...radio, department0: selTree, company: selCompany }
          : { ...radio, department0: selTree },
      };
      // console.log({ sendData });
      const res = await Axios.post(
        '/api/dbModel100/makeReport10010_company',
        sendData
      );
      // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
      message.success({
        content: 'ファイル生成完了！',
        key: 'makecsv',
        duration: 2,
      });
      setSubmitSW(true);
      setIsModalVisible(false);
      openReport(res.data.tokenId);
    } catch (error) {
      console.log(error.message);
      setIsModalVisible(false);
      message.error({
        content: error.message,
        key: 'makecsv',
        duration: 4,
      });
      setSelSurveySeasonId('');
      setSelGroupCode('');
      setSelGroupInfo([]);
      setSubmitSW(true);

      // window.location.reload(false);
    }
  };

  const handleChangeTree0 = (value, label, extra) => {
    // console.log({ value });
    setSelTree(value);
    if (value) {
      setRadio({
        ...radio,
        radio03: 1,
      });
    } else {
      setRadio({
        ...radio,
        radio03: 0,
      });
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '1100px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>人事評価力組織診断結果ダウンロード(PDF)</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Select
              showSearch
              style={{ marginLeft: 0, marginRight: 10, width: 300 }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={selGroupCode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={userInfo.role === 3 || userInfo.role === 7}
            >
              {groups.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>サーベイを選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 5, width: 400 }}
                placeholder="サーベイ選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groupSurveySeasonInfo.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
          {isAffiliate && (
            <CompanySelectBlock
              names={companyNames}
              value={selCompany}
              onChange={onChangeCompany}
            />
          )}
          <br />
          <br />
          <Card
            type="inner"
            style={{ marginTop: 16, width: 700 }}
            title="部署選択"
            extra={
              <Button
                size="small"
                onClick={(e) => handleChangeTree0('', null, null)}
                disabled={!selTree || depAll}
              >
                選択クリア
              </Button>
            }
          >
            <Space direction="vertical">
              {orgNoticeDate && (
                <Text type="secondary">
                  組織情報管理の確定組織表（{orgNoticeDate} 時点）の部署一覧を表示しています
                </Text>
              )}
              <Text>部署選択 ▶︎ {selTree ? selTree : '全部署'} </Text>
              <TreeSelect
                {...DEPT_TREE_SELECT_PROPS}
                style={{ width: '100%', maxWidth: 800 }}
                treeData={treeData}
                onSelect={handleChangeTree0}
                value={selTree}
              />
            </Space>
          </Card>
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button
            type="default" className="ds-btn-secondary"
            size="large"
            onClick={onSubmit}
            disabled={!(submitSW && selSurveySeasonId)}
          >
            ダウンロード
          </Button>
        </Form>
      </div>
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
};

export default PDF10010CompanyDowlnoadPage;
